module.exports = __webpack_public_path__ + "img/avatar3.4a4e280a.png";